export default __webpack_public_path__ + "static/wave-75c6b89a8d1ffadf72071a9367343d71.png";